import type { FAQPolicyValues } from "../faq-data.ts";
import type { FaqBuilder } from "./index.ts";

const buildFaqsEn: FaqBuilder = (p: FAQPolicyValues, fmt) => {
  const secondaryLine =
    p.secondaryCountryName && p.secondaryFreeAbove
      ? ` Shipping to Belgium is free from ${fmt.eur(p.secondaryFreeAbove)} EUR.`
      : "";
  return [
    {
      category: "Products & allergies",
      items: [
        {
          q: "I have an allergy, are your products suitable for me?",
          a: "In almost all cases, our products are suitable. Send us an email with your specific allergy and we'll personally advise you which products are safe for you. You can also order a sample first to test the product on a small patch of skin.",
        },
        {
          q: "What does hypoallergenic mean?",
          a: "Hypoallergenic means the chance of an allergic reaction is extremely small. All Unity Cosmetics products are hypoallergenic. We deliberately choose ingredients that carry as little risk of irritation as possible.",
        },
        {
          q: "How can I test whether a product is suitable for me?",
          a: "We recommend trying the product first on a small patch on the inside of your elbow. If you have a sensitivity or allergic reaction, this usually shows up within 24 hours as itching, mild redness and sometimes small bumps. Samples are available for most products.",
        },
        {
          q: "Are your products vegan?",
          a: "A large part of our range is vegan. The product page states under the classifications whether the product is vegan. All products are cruelty-free.",
        },
        {
          q: "Do your products contain gluten?",
          a: "All our products are gluten-free. This is also stated under the classifications on the product page.",
        },
      ],
    },
    {
      category: "Ordering & payment",
      items: [
        {
          q: "Which payment methods do you accept?",
          a: "We accept iDEAL, Visa, Mastercard, PayPal, Klarna (buy now, pay later), Bancontact, and SEPA bank transfer.",
        },
        {
          q: "When will I receive my order?",
          a: `Orders are delivered within ${fmt.deliveryWindow} via ${p.carrier} with Track & Trace. You'll receive a confirmation email with a tracking code as soon as your parcel has been shipped.`,
        },
        {
          q: "Is shipping free?",
          a: `Yes, on orders from ${fmt.eur(p.primaryFreeAbove)} EUR, shipping within the Netherlands is free.${secondaryLine}`,
        },
        {
          q: "Can I order samples too?",
          a: "Yes, samples are available for most products. This lets you test the product on your skin before buying the full size.",
        },
      ],
    },
    {
      category: "Returns",
      items: [
        {
          q: "Can I return a product?",
          a: `You have ${p.returnWindowDays} days to change your mind after receiving your order. Products must be returned unopened and in their original packaging. Return shipping costs are at your own expense (approx. ${fmt.eur(p.returnCost)} EUR).`,
        },
        {
          q: "What if I have an allergic reaction?",
          a: "Contact us right away. Although the chance is extremely small with our products, we take every reaction seriously. We'll help you find a suitable solution.",
        },
      ],
    },
  ];
};

export default buildFaqsEn;
